import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";
import { resetDataComponent } from "../../StateManagement/actions";

export const ExpenseList: React.FC<any> = React.memo(() => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getExpensePermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const { open, title, onConfirm, handleClose, openConfirmDialog } =
    useConfirmDialog();
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();

  useEffect(() => {
    updateMainHeader("Expenses");
    breadCrumbsStore.updateBreadCrumbs([{ Expenses: "" }]);
  }, []);

  const source = {
    url: "Expenses/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [{ field: "UpdatedAt", direction: "desc" }],
  };

  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI("Expenses", Method.DELETE, null, id);
    dispatch(resetDataComponent("expenseMainListGrid"));
    if (response?.success) {
      showMessage(response?.message, "success");
    } else {
      showMessage(response?.message || "Something went wrong", "error");
    }
    handleClose();
  };

  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/expense/edit/${row?.id}`);
    } else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id));
    }
  };

  const columns: IColumns[] = [
    { header: "Expense Type", fieldName: "expenseType", type: "default" },
    { header: "Paid Through", fieldName: "paidThrough", type: "default" },
    { header: "Amount", fieldName: "taxAmount", type: "default" },
    { header: "Invoice Number", fieldName: "invoiceNumber", type: "default" },
    
    { header: "Date", fieldName: "date", type: "date" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(
        Boolean
      ),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const mobColumns: IOrderColumns[] = [
    {
      header: "Expense Type",
      fieldName: "expenseType",
      type: "default",
      labelSx: { fontWeight: "bold" },
    },
    { header: "Amount", fieldName: "taxAmount", type: "default" },
    { header: "Date", fieldName: "date", type: "date" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/expense/add");
  };

  return (
    <>
      <Grid container spacing={2}>
        {view ? (
          <Grid item xs={12}>
            {!isMobile && (
              <WSDataGrid
                id="expenseMainListGrid"
                title="Expenses"
                columns={columns}
                source={source}
                searchBox={{ fieldName: "invoiceNumber" }}
                addButton={add ? { label: "New", color: "secondary" } : undefined}
                onAddButtonClick={handleClick}
                gridHeaderSx={{
                  backgroundColor: "whitesmoke",
                  border: "1px solid whitesmoke",
                }}
              
              />
            )}
            {isMobile && (
              <WSMobileDataGridAdvanced
                title={"Expenses"}
                addButton={add ? { label: "New", color: "secondary" } : undefined}
                onAddButtonClick={handleClick}
                columns={mobColumns}
                id="expenseMainListGrid"
                source={source}
              />
            )}
          </Grid>
        ) : (
          <PermissionDenied />
        )}
        <ConfirmDialog
          open={open}
          title={title}
          onConfirm={onConfirm}
          onClose={handleClose}
        />
      </Grid>
    </>
  );
});
